function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#002A33;}\n\t.st2{clip-path:url(#SVGID_00000085969387879535861370000011609627396805804218_);}\n\t.st3{fill:#6CB9B2;}\n\t.st4{fill:url(#SVGID_00000026863440175718261730000015970227659059647406_);}\n\t.st5{opacity:0.22;fill:#421115;enable-background:new    ;}\n\t.st6{opacity:0.91;fill:#E8E6FD;enable-background:new    ;}\n\t.st7{opacity:0.34;fill:#D3CFCC;enable-background:new    ;}\n\t.st8{fill:url(#SVGID_00000001633303254374783830000015702476599828183951_);}\n\t.st9{fill:url(#SVGID_00000157271870163522770370000004018169251386593436_);}\n\t.st10{opacity:0.5;fill:#D27621;enable-background:new    ;}\n\t.st11{fill:url(#SVGID_00000087405818359258327320000003096452900589594262_);}\n\t.st12{fill:url(#SVGID_00000017479655050170713770000012037047583471385483_);}\n\t.st13{opacity:0.35;fill:url(#SVGID_00000065757878607273920930000012736948615029246106_);enable-background:new    ;}\n\t.st14{fill:#D27621;}\n\t.st15{fill:#DC8228;}\n\t.st16{fill:url(#SVGID_00000171686019296194787130000013086651369053185184_);}\n\t.st17{opacity:0.36;fill:#F5F5F5;enable-background:new    ;}\n\t.st18{fill:#F5F5F5;}\n\t.st19{fill:url(#SVGID_00000018922419131461431360000004793887765499891624_);}\n\t.st20{fill:#FDD53D;}\n\t.st21{fill:#FDE384;}\n\t.st22{fill:url(#SVGID_00000090268457598686093920000007592505983997889974_);}\n\t.st23{fill:url(#SVGID_00000066473373245270831970000003330149804317595023_);}\n\t.st24{fill:url(#SVGID_00000081605313147954334790000005588656672176452516_);}\n\t.st25{fill:url(#SVGID_00000053508877069081359730000012262037747340793021_);}\n\t.st26{fill:url(#SVGID_00000140695681821125762280000007210002738663597753_);}\n\t.st27{fill:url(#SVGID_00000056412193731330903480000015114493245355664292_);}\n\t.st28{fill:url(#SVGID_00000143585754177169357220000006709768397670598059_);}\n\t.st29{fill:url(#SVGID_00000126304184663289147740000010025858668568736906_);}\n\t.st30{fill:url(#SVGID_00000074405766903541518150000016541942999809211070_);}\n\t.st31{opacity:0.46;fill:#FDE384;enable-background:new    ;}\n\t.st32{fill:url(#SVGID_00000000193546745658252680000011591596135892178059_);}\n\t.st33{fill:url(#SVGID_00000017500567404449962810000002829886877896133798_);}\n\t.st34{fill:url(#SVGID_00000052793826194169391130000017168848834960824200_);}\n\t.st35{fill:url(#SVGID_00000107563841996198441330000009701207674610213053_);}\n\t.st36{fill:url(#SVGID_00000049195347366408647110000010573266158784343461_);}\n\t.st37{fill:url(#SVGID_00000070822825750918826120000001865907449571634074_);}\n\t.st38{fill:url(#SVGID_00000110455515598077753400000017862421777892298380_);}\n\t.st39{fill:url(#SVGID_00000093177389301016731240000013234395484893147310_);}\n\t.st40{fill:url(#SVGID_00000084529014283960715520000004037947451036560057_);}\n\t.st41{fill:url(#SVGID_00000053525513513161305180000013752534532606507427_);}\n\t.st42{fill:url(#SVGID_00000157991848883462273980000009553668758062384267_);}\n\t.st43{fill:url(#SVGID_00000034051323748598301660000009944639758321709230_);}\n\t.st44{fill:url(#SVGID_00000053546010922626974250000000493930417159929216_);}\n\t.st45{fill:url(#SVGID_00000121241475257039928290000014135508438717992370_);}\n\t.st46{opacity:0.55;fill:#E8E6FD;enable-background:new    ;}\n\t.st47{opacity:0.35;fill:url(#SVGID_00000064317597194748971300000017972061510732017838_);enable-background:new    ;}\n\t.st48{fill:url(#SVGID_00000049920988584954534580000017123494138781364885_);}\n\t.st49{opacity:0.35;fill:url(#SVGID_00000041994856528412185340000002523629944191812744_);enable-background:new    ;}\n\t.st50{fill:url(#SVGID_00000019678454724897234450000011668785783741977475_);}\n\t.st51{opacity:0.35;fill:url(#SVGID_00000066492033819738677570000013202014342360353431_);enable-background:new    ;}\n\t.st52{fill:url(#SVGID_00000106833684417993724800000013161617022252596380_);}\n\t.st53{opacity:0.35;fill:url(#SVGID_00000124123684263937549350000003038062786549594247_);enable-background:new    ;}\n\t.st54{fill:url(#SVGID_00000004528530123965084930000006153038164967968688_);}\n\t.st55{opacity:0.35;fill:url(#SVGID_00000057129711412067881200000014663127791736690819_);enable-background:new    ;}\n\t.st56{fill:url(#SVGID_00000079478162898060043280000004248906530777096867_);}\n\t.st57{opacity:0.35;fill:url(#SVGID_00000129198384105872412890000014621343638174447771_);enable-background:new    ;}\n\t.st58{fill:url(#SVGID_00000047763090961946350160000008508250029649908158_);}\n\t.st59{opacity:0.35;fill:url(#SVGID_00000163792202512516691520000016139834231067870339_);enable-background:new    ;}\n\t.st60{fill:url(#SVGID_00000000937884762173465730000017361265392503944340_);}\n\t.st61{opacity:0.35;fill:url(#SVGID_00000090257997674769833440000015182446605000201868_);enable-background:new    ;}\n\t.st62{fill:url(#SVGID_00000087406611144295570990000016013711238567347615_);}\n\t.st63{opacity:0.35;fill:url(#SVGID_00000143609805497065704000000013160988215898022053_);enable-background:new    ;}\n\t.st64{fill:url(#SVGID_00000038404111598090466910000000233346363423157123_);}\n\t.st65{opacity:0.35;fill:url(#SVGID_00000005238302025472479640000001836368212323847090_);enable-background:new    ;}\n\t.st66{fill:url(#SVGID_00000003072678467189418280000000184395540816232324_);}\n\t.st67{opacity:0.35;fill:url(#SVGID_00000058561809015612938800000007944885354486708148_);enable-background:new    ;}\n\t.st68{fill:url(#SVGID_00000062178102499356756680000015740575635829039765_);}\n\t.st69{opacity:0.35;fill:url(#SVGID_00000170238788341251166640000006411408664638840720_);enable-background:new    ;}\n\t.st70{fill:url(#SVGID_00000080208787466098355070000017219947653244201399_);}\n\t.st71{opacity:0.35;fill:url(#SVGID_00000171699244399178001570000003804851453150232462_);enable-background:new    ;}\n\t.st72{fill:url(#SVGID_00000055709507351427126100000002619968455940110777_);}\n\t.st73{opacity:0.35;fill:url(#SVGID_00000173844733462264605330000000166692155362725282_);enable-background:new    ;}\n\t.st74{fill:url(#SVGID_00000072971940320093214600000014482551902903352724_);}\n\t.st75{opacity:0.35;fill:url(#SVGID_00000149374675211335632960000005436726115890735548_);enable-background:new    ;}\n\t.st76{fill:url(#SVGID_00000171696949286104234210000016228870272490403980_);}\n\t.st77{opacity:0.34;fill:#E8E6FD;enable-background:new    ;}\n\t.st78{fill:#E8E6FD;}\n\t.st79{opacity:0.43;fill:#E8E6FD;enable-background:new    ;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 139.9,
  cy: 139.9,
  r: 131.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M139.9,279.7C62.7,279.7,0,217,0,139.9S62.7,0,139.9,0s139.9,62.7,139.9,139.9S217,279.7,139.9,279.7z  M139.9,17C72.1,17,17,72.1,17,139.9s55.1,122.9,122.9,122.9s122.9-55.1,122.9-122.9S207.6,17,139.9,17z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "SVGID_1_",
  cx: 140,
  cy: 139.8,
  rx: 123.1,
  ry: 122.6
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: -22.6,
  y: -9.5,
  className: "st3",
  width: 319.4,
  height: 319.4
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M132.1,176.3c5.3-6.3,21.1-14.3,39.2-17.7l13.8,38.3c-2.1-0.6-4.2,0-5.2,3.6c-2.8,9.3-8.3,6.7-12.3,3.6 s-9.2,0.7-11.6,5.9s-8.1,3.5-10.6-0.5c-1.8-2.8-4.6-0.6-6.1,1.1l-9.8-27.1C129.9,180.7,130.6,178.1,132.1,176.3L132.1,176.3z "
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M192.3,216.8l5.9,16.3l-26.8-5.1l-18.2,21.3l-6-16.6C162.9,215.6,182.6,215.6,192.3,216.8L192.3,216.8z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M194.5,230.1c0.3,0.6-24.2-6.7-24.2-6.7l-16,20.7l-11.2-22.9l10.1,28.1l18.2-21.3l26.8,5.1l-12.6-35 C188.4,208.9,194.3,229.7,194.5,230.1L194.5,230.1z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M149.8,174.5c-5.6-7-22.6-16.2-42.2-20.4l-16.2,41.3c2.3-0.6,4.5,0.1,5.6,4.1c2.7,10.2,8.9,7.5,13.3,4.3 c4.5-3.2,10,1,12.4,6.8s8.7,4,11.6-0.2c2-3,5-0.5,6.6,1.3l11.4-29.2C152.2,179.3,151.4,176.5,149.8,174.5L149.8,174.5z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M83,216.9l-6.9,17.6l29.4-4.8l19.2,23.8l7-18C115,216.4,93.6,215.9,83,216.9z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M142.4,205.4l-18.6,42L107,224.8c0,0-25.2,6-25.7,5.7c-0.4-0.2,8.3-28.7,10.8-37l-16,41l29.4-4.8 l19.2,23.8l17.2-44L142.4,205.4L142.4,205.4z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M215.5,123.3c0,41.2-33.4,74.7-74.6,74.7s-74.7-33.4-74.7-74.7s33.4-74.7,74.7-74.7 S215.5,82.1,215.5,123.3L215.5,123.3z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M140.9,186.8c-35,0-63.4-28.5-63.4-63.4s28.5-63.4,63.4-63.4s63.4,28.5,63.4,63.4 S175.9,186.8,140.9,186.8z M140.9,62.3c-33.7,0-61.1,27.4-61.1,61.1s27.4,61.1,61.1,61.1s61.1-27.4,61.1-61.1 S174.6,62.3,140.9,62.3z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M117.2,162.7v-1.6c0-2.8,0-10.4,0.2-13.3l0.1-1.4l14.9-0.3v-38c-4.1,0.5-8.4,1.1-14.1,1.8l-1.5,0.2 l-0.3-1.5c-0.5-2.5-1-5.7-1.4-8.7l-0.2-1.3l1.3-0.4c7.4-2.1,20.8-10.3,28.1-14.7c5.4-3.3,5.8-3.5,6.5-3.5c1,0,2,0.7,2,2.1 c0,10.5-0.1,26.6-0.2,42.2v0.3c-0.1,7.8-0.1,15.3-0.2,21.5l14.3,0.3v1.6c0,2.8-0.1,10.4-0.2,13.1l-0.1,1.5h-24.7 c-3.1,0-6.4,0-9.9,0.1c-4,0-8.3,0.1-13,0.1L117.2,162.7L117.2,162.7z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M163.6,149.8c0.4,2.5,0.5,8.3-1.2,10.4h2.6c0.1-2.7,0.2-10.2,0.2-13.1l-5.3-0.1 C161.5,147.5,163.3,148.4,163.6,149.8L163.6,149.8z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M141.7,158.3c2.1-6,5.4-10.9,9.1-14.4c0.1-18.5,0.4-47.1,0.4-62.6c0-0.4-0.2-0.5-0.4-0.5 c-1,0-23.4,15.1-34.2,18.1c0.1,1.2,0.3,2.4,0.5,3.7c0.8-1.3,2.4-2.7,5.3-4c8-3.5,21.4-13.4,24-0.7c2.6,12.7-2.1,46-9.6,50.7 c-6.7,4.2-11.5,1.7-13-1.6l-4.8,0.1c-0.2,2.9-0.2,10.4-0.2,13.2c8.6,0,15.8-0.1,22.4-0.1C141.3,159.6,141.5,159,141.7,158.3 L141.7,158.3z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M124.6,96.8c0,0-4.3,1-3.7,1.8C121.5,99.3,127.2,97,124.6,96.8z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M147.8,83.8c0,0-17.2,9.6-18.6,10.6C127.8,95.2,144.6,90.2,147.8,83.8z"
});

var _ref19 = /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "140.4,51.2 140.4,55.2 143.5,55.2 143.5,55.2 140.4,51.2  "
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "140.4,55.1 137.2,55.1 137.2,55.2 140.4,59.1 140.4,59.1  "
});

var _ref21 = /*#__PURE__*/React.createElement("polygon", {
  className: "st21",
  points: "140.3,51.9 140.1,55 138.1,55.2 140.1,55.3 140.4,58.1 140.5,55.3 142.8,55.2 140.5,54.9  "
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "140.4,187.6 140.4,191.6 143.5,191.6 143.5,191.6 140.4,187.6  "
});

var _ref23 = /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "140.4,191.6 137.2,191.6 137.2,191.6 140.4,195.6 140.4,195.5  "
});

var _ref24 = /*#__PURE__*/React.createElement("polygon", {
  className: "st21",
  points: "140.3,188.3 140.1,191.4 138.1,191.6 140.1,191.7 140.4,194.5 140.5,191.7 142.8,191.6  140.5,191.4  "
});

var _ref25 = /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "68.2,123.4 72.2,123.4 72.2,120.2 72.1,120.2 68.2,123.4  "
});

var _ref26 = /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "72.1,123.3 72.1,126.5 72.1,126.5 76.1,123.4 76.1,123.3  "
});

var _ref27 = /*#__PURE__*/React.createElement("polygon", {
  className: "st21",
  points: "68.9,123.4 71.9,123.6 72.1,125.7 72.3,123.6 75.1,123.4 72.3,123.2 72.2,120.9 71.9,123.2  "
});

var _ref28 = /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "204.6,123.4 208.6,123.4 208.6,120.2 208.6,120.2 204.6,123.4  "
});

var _ref29 = /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "208.6,123.3 208.6,126.5 208.6,126.5 212.6,123.4 212.5,123.3  "
});

var _ref30 = /*#__PURE__*/React.createElement("polygon", {
  className: "st21",
  points: "205.3,123.4 208.4,123.6 208.6,125.7 208.7,123.6 211.5,123.4 208.7,123.2 208.6,120.9  208.4,123.2  "
});

var _ref31 = /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "191.4,72.3 188.6,75.1 190.8,77.4 190.8,77.3 191.4,72.3  "
});

var _ref32 = /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "188.6,75.1 186.4,72.9 186.4,72.9 185.8,77.9 185.8,77.9  "
});

var _ref33 = /*#__PURE__*/React.createElement("polygon", {
  className: "st21",
  points: "190.9,72.8 188.6,74.8 187,73.5 188.3,75.1 186.6,77.2 188.6,75.3 190.3,76.9 188.9,75.1  "
});

var _ref34 = /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "94.9,168.8 92.1,171.6 94.3,173.8 94.3,173.8 94.9,168.8  "
});

var _ref35 = /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "92.2,171.6 89.9,169.4 89.9,169.4 89.3,174.4 89.3,174.4  "
});

var _ref36 = /*#__PURE__*/React.createElement("polygon", {
  className: "st21",
  points: "94.4,169.3 92.1,171.3 90.5,170 91.8,171.5 90.1,173.7 92.1,171.8 93.8,173.4 92.4,171.6  "
});

var _ref37 = /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "89.3,72.3 92.1,75.2 94.3,72.9 94.3,72.9 89.3,72.3  "
});

var _ref38 = /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "92.1,75.1 89.9,77.3 89.9,77.3 94.9,77.9 94.9,77.9  "
});

var _ref39 = /*#__PURE__*/React.createElement("polygon", {
  className: "st21",
  points: "89.8,72.9 91.8,75.2 90.5,76.8 92.1,75.4 94.2,77.2 92.3,75.2 93.9,73.4 92.1,74.9  "
});

var _ref40 = /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "185.8,168.8 188.6,171.6 190.8,169.4 190.8,169.4 185.8,168.8  "
});

var _ref41 = /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "188.6,171.6 186.4,173.8 186.4,173.8 191.4,174.4 191.4,174.4  "
});

var _ref42 = /*#__PURE__*/React.createElement("polygon", {
  className: "st21",
  points: "186.3,169.3 188.3,171.6 187,173.2 188.5,171.9 190.7,173.7 188.8,171.6 190.4,169.9  188.6,171.3  "
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M112.6,64c-1.7,0-3.1-1.4-3.1-3.1c0-0.1,0-0.2,0-0.3c-0.1,0.3-0.1,0.5-0.1,0.8c0,1.7,1.4,3.1,3.1,3.1 c1.6,0,2.8-1.2,3-2.7C115.1,63,114,64,112.6,64z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M114.3,59.9c0,0.7-0.8,1.3-1.7,1.3s-1.7-0.6-1.7-1.3s0.8-1.3,1.7-1.3S114.3,59.2,114.3,59.9z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M166.6,62.7c-1.7,0-3.1-1.4-3.1-3.1c0-0.1,0-0.2,0-0.3c-0.1,0.3-0.1,0.5-0.1,0.8c0,1.7,1.4,3.1,3.1,3.1 c1.6,0,2.9-1.2,3-2.7C169.2,61.8,168,62.7,166.6,62.7L166.6,62.7z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M168.4,58.6c0,0.7-0.8,1.3-1.7,1.3s-1.7-0.6-1.7-1.3s0.8-1.3,1.7-1.3S168.4,57.9,168.4,58.6z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M202.9,97.8c-1.7,0-3.1-1.4-3.1-3.1c0-0.1,0-0.2,0-0.3c-0.1,0.3-0.1,0.5-0.1,0.8c0,1.7,1.4,3.1,3.1,3.1 c1.6,0,2.9-1.2,3-2.7C205.4,96.8,204.3,97.8,202.9,97.8z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M204.6,93.7c0,0.7-0.8,1.3-1.7,1.3s-1.7-0.6-1.7-1.3s0.8-1.3,1.7-1.3S204.6,92.9,204.6,93.7z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M204.4,150.1c-1.7,0-3.1-1.4-3.1-3.1c0-0.1,0-0.2,0-0.3c-0.1,0.3-0.1,0.5-0.1,0.8 c0,1.7,1.4,3.1,3.1,3.1c1.6,0,2.9-1.2,3-2.7C207,149.1,205.9,150.1,204.4,150.1L204.4,150.1z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M206.2,146c0,0.7-0.8,1.3-1.7,1.3s-1.7-0.6-1.7-1.3s0.8-1.3,1.7-1.3S206.2,145.3,206.2,146z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M78.1,151.2c-1.7,0-3.1-1.4-3.1-3.1c0-0.1,0-0.2,0-0.4c-0.1,0.3-0.1,0.5-0.1,0.8c0,1.7,1.4,3.1,3.1,3.1 c1.6,0,2.8-1.2,3-2.7C80.6,150.2,79.5,151.2,78.1,151.2L78.1,151.2z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M79.8,147.1c0,0.7-0.8,1.3-1.7,1.3s-1.7-0.6-1.7-1.3s0.8-1.3,1.7-1.3S79.8,146.3,79.8,147.1z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M114.8,188.4c-1.7,0-3.1-1.4-3.1-3.1c0-0.1,0-0.2,0-0.3c-0.1,0.3-0.1,0.5-0.1,0.8 c0,1.7,1.4,3.1,3.1,3.1c1.6,0,2.8-1.2,3-2.7C117.4,187.5,116.2,188.4,114.8,188.4z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M116.6,184.3c0,0.7-0.8,1.3-1.7,1.3s-1.7-0.6-1.7-1.3s0.8-1.3,1.7-1.3S116.6,183.6,116.6,184.3z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M168.2,187.4c-1.7,0-3.1-1.4-3.1-3.1c0-0.1,0-0.2,0-0.4c-0.1,0.3-0.1,0.5-0.1,0.8 c0,1.7,1.4,3.1,3.1,3.1c1.6,0,2.9-1.2,3-2.7C170.8,186.4,169.6,187.4,168.2,187.4L168.2,187.4z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M170,183.3c0,0.7-0.8,1.3-1.7,1.3s-1.7-0.6-1.7-1.3s0.8-1.3,1.7-1.3S170,182.5,170,183.3z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M77.5,101.2c-1.7,0-3.1-1.4-3.1-3.1c0-0.1,0-0.2,0-0.3c-0.1,0.3-0.1,0.5-0.1,0.8c0,1.7,1.4,3.1,3.1,3.1 c1.6,0,2.8-1.2,3-2.7C80.1,100.2,78.9,101.2,77.5,101.2z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M79.3,97.1c0,0.7-0.8,1.3-1.7,1.3s-1.7-0.6-1.7-1.3s0.8-1.3,1.7-1.3S79.3,96.4,79.3,97.1z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "st46",
  d: "M171,58.7c0,0,1.4,3.2-0.4,4.7c-1.8,1.5,0.9,1.1,5.9,5s7.7,5.8,7.7,5.8s1-2.4,2-2.6 c1.9-0.2,3.2-0.2,3.2-0.2S182.8,64.2,171,58.7L171,58.7z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "st46",
  d: "M192.4,74.5c0,0,0,4.5-2.1,4.5c-1,0-1.1,0.2-0.4,0.8c0.6,0.5,7,9.8,8.5,12.9c0,0,2.2-3.3,5.7-2.2 C204,90.4,198.9,80.3,192.4,74.5L192.4,74.5z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "st77",
  d: "M206.6,97.7c0,0-1.6,3.2-4.8,1.8c0,0,1.8,5.1,2.9,10.8c1.2,5.7,1.6,9.8,1.6,9.8s1.8-1.8,2.5-1.3 c0.7,0.4,3.4,2.6,3.4,2.6S212.6,112.2,206.6,97.7L206.6,97.7z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "st77",
  d: "M161.5,61.2c0,0-8.6-2.8-17.4-3c0,0,1.7-2.2,1.6-2.8c-0.1-0.6-2.2-2.8-2.2-2.8s9.5-0.5,19.4,3.6 C163,56.2,160,59.4,161.5,61.2L161.5,61.2z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  className: "st46",
  d: "M88.4,169c0.9-1.3,2.1-2.1,3.5-2.6c-0.8-1-2.6-3.4-5.4-7.1c-3.9-5-3.5-7.8-5-5.9s-4.7,0.4-4.7,0.4 c3.8,8.2,8.4,13.9,10.9,16.6C87.8,169.9,88.1,169.4,88.4,169L88.4,169z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  className: "st46",
  d: "M110.8,180.8c-3.2-1.4-12.6-7.4-13.2-8c0,0-0.1-0.1-0.1-0.1c-0.2,0.3-0.4,0.6-0.7,0.8 c-0.1,0.8-0.9,1.3-1.8,1.6c-0.3,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.6,0.1-0.9,0.1c-0.2,0-0.5,0.1-0.6,0.1c-0.1,0-0.1,0-0.2,0.1 c6,6.3,16.2,10.9,16.2,10.9C107.6,183.1,110.8,180.8,110.8,180.8L110.8,180.8z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "st77",
  d: "M135.8,191.9c-0.1-0.9,0.6-2.1,0.9-3c-1.7-0.2-4.7-0.7-8.4-1.4s-7.1-1.8-9.1-2.4 c-0.2,1.8-1.1,3.5-2.3,4.8c9.2,3.7,16.2,4.7,19.8,5C136.4,193.9,135.7,193,135.8,191.9L135.8,191.9z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  className: "st77",
  d: "M79.2,144.3c0,0-2.8-8.6-3-17.4c0,0-2.2,1.7-2.8,1.6s-2.8-2.2-2.8-2.2s-0.5,9.5,3.6,19.4 C74.3,145.8,77.5,142.8,79.2,144.3L79.2,144.3z"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  className: "st78",
  d: "M163.3,73.5c0,0-6.8,0.5,3.2,8.4c10,7.9,20.8,20.7,22.4,16C190.7,92.3,175.7,74.5,163.3,73.5L163.3,73.5 z"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "st79",
  d: "M137.2,181.7c0,0,5.2-1.1-6.8-5.3c-12-4.2-25.8-14.3-25.3-9.5C105.6,171.7,130.6,183.7,137.2,181.7z"
});

function SvgQ8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 279.7 279.7",
    style: {
      enableBackground: "new 0 0 279.7 279.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000003107409332179320410000017938338300922065845_"
  }, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000087401939189949442840000017563085163571792298_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000087401939189949442840000017563085163571792298_)"
    }
  }, _ref5, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010990891440726575400000017334964575246622108_",
    gradientUnits: "userSpaceOnUse",
    x1: -5463.6279,
    y1: -80.6198,
    x2: -5424.438,
    y2: 24.5802,
    gradientTransform: "matrix(-0.998 6.261627e-02 -6.261627e-02 -0.998 -5277.145 505.9276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C41839"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000010990891440726575400000017334964575246622108_)"
    },
    points: "198.2,233.1 166.4,144.9  121.4,161.1 153.2,249.3 171.4,228  "
  }), _ref6, _ref7, _ref8), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008127025007089983700000010583175985015595397_",
    gradientUnits: "userSpaceOnUse",
    x1: -67.0535,
    y1: 312.5392,
    x2: -24.2835,
    y2: 427.3692,
    gradientTransform: "matrix(0.996 8.924197e-02 8.924197e-02 -0.996 133.4742 564.7903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C41839"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000008127025007089983700000010583175985015595397_)"
    },
    points: "76.1,234.6 113.4,139.2  162,158.2 124.7,253.5 105.5,229.7  "
  }), _ref9, _ref10, _ref11), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110445839727585790560000001702772058662356385_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.2132,
    y1: 373.4587,
    x2: 86.6131,
    y2: 22.0688,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110445839727585790560000001702772058662356385_)"
    },
    d: "M135.4,44.8c3-5.1,8-5.1,11,0 c3,5.1,9.1,6,13.6,2.2c4.4-3.9,9.1-2.3,10.4,3.4c1.3,5.8,6.8,8.5,12.2,6.2c5.4-2.3,9.4,0.6,8.9,6.5s3.8,10.2,9.7,9.7 s8.8,3.5,6.4,8.9s0.5,10.9,6.2,12.2c5.8,1.3,7.3,6,3.4,10.4c-3.9,4.4-2.9,10.5,2.1,13.6c5.1,3,5.1,8,0,11 c-5.1,3-6,9.1-2.1,13.6c3.9,4.4,2.4,9.1-3.4,10.4c-5.7,1.3-8.6,6.8-6.2,12.2s-0.6,9.4-6.4,8.9s-10.2,3.8-9.7,9.7 s-3.5,8.8-8.9,6.4s-10.9,0.5-12.2,6.2c-1.3,5.8-6,7.3-10.4,3.4c-4.4-3.9-10.5-2.9-13.6,2.1s-8,5.1-11,0c-3-5.1-9.1-6-13.6-2.1 c-4.4,3.9-9.1,2.4-10.4-3.4c-1.3-5.7-6.8-8.6-12.2-6.2c-5.4,2.3-9.4-0.6-8.9-6.4c0.5-5.9-3.8-10.2-9.7-9.7s-8.8-3.5-6.4-8.9 s-0.5-10.9-6.2-12.2c-5.7-1.3-7.3-6-3.4-10.4c3.9-4.4,2.9-10.5-2.2-13.6c-5.1-3-5.1-8,0-11c5.1-3,6-9.1,2.2-13.6 c-3.9-4.4-2.3-9.1,3.4-10.4c5.8-1.3,8.6-6.8,6.2-12.2c-2.3-5.4,0.6-9.4,6.4-8.9c5.9,0.5,10.2-3.8,9.7-9.7 c-0.5-5.9,3.5-8.8,8.9-6.5s10.9-0.5,12.2-6.2c1.3-5.8,6-7.3,10.4-3.4C126.3,50.9,132.4,49.9,135.4,44.8z"
  }), _ref12, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076601805618444520550000010312819652804780188_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.1651,
    y1: 388.9988,
    x2: 107.1151,
    y2: 15.4088,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076601805618444520550000010312819652804780188_)"
    },
    d: "M213.6,123.3 c0,40.2-32.6,72.7-72.7,72.7s-72.7-32.5-72.7-72.7s32.5-72.7,72.7-72.7S213.6,83.2,213.6,123.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098935791642893530980000014969231457746642048_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.4405,
    y1: 261.0399,
    x2: 102.0005,
    y2: 8.8199,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098935791642893530980000014969231457746642048_)"
    },
    d: "M203.1,123.3 c0,34.4-27.9,62.2-62.2,62.2s-62.2-27.9-62.2-62.2s27.9-62.2,62.2-62.2S203.1,89,203.1,123.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042707139495364265990000006918919802054053768_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.7643,
    y1: -63.5819,
    x2: 273.0943,
    y2: 439.2981,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000042707139495364265990000006918919802054053768_)",
      enableBackground: "new"
    },
    d: " M140.9,61.1c-3.9,0-7.6,0.4-11.3,1c8.3-0.2,17,1.1,24.3,5.5c21.6,12.9-2.5,76.1-29.5,92.1c-16.3,9.7-28.5,3.8-35.3-1.9 c11.2,16.7,30.2,27.7,51.8,27.7c2.9,0,5.7-0.2,8.5-0.6c-5.3-2.2-9.8-6.3-9-14.9c1.7-18.5,28.4-69.1,45.8-67.1 c8.8,1,14,7.6,16.8,14.9C200.1,86.1,173.4,61.1,140.9,61.1L140.9,61.1z"
  }), _ref13, /*#__PURE__*/React.createElement("g", null, _ref14, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114758862132988330750000014064067711026863009_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.8013,
    y1: 350.0694,
    x2: 56.4014,
    y2: -37.0106,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114758862132988330750000014064067711026863009_)"
    },
    d: "M165.1,147.1 c0,2.9-0.1,10.4-0.2,13.1h-23.2c-6.7,0-14.2,0.1-23,0.1c0-2.8,0-10.3,0.2-13.2l14.5-0.3c0.3,0,0.5-0.3,0.5-0.6v-40.8 c-5,0.6-9.7,1.2-15.9,2.1c-0.5-2.8-1-5.8-1.3-8.6c10.8-3,33.1-18.1,34.2-18.1c0.2,0,0.4,0.1,0.4,0.5 c0,16.3-0.3,47.2-0.4,65.5L165.1,147.1L165.1,147.1z"
  }), _ref15, _ref16, _ref17, _ref18), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017510605051915706760000008571984977420533636_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.1945,
    y1: 236.5122,
    x2: 137.9145,
    y2: 220.6922,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000017510605051915706760000008571984977420533636_)"
    },
    points: "140.4,51.2 137.2,55.2  140.4,59.1 143.5,55.2  "
  }), _ref19, _ref20), _ref21), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147193278506221902050000011458589193688449956_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.1966,
    y1: 100.0813,
    x2: 137.9166,
    y2: 84.2713,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000147193278506221902050000011458589193688449956_)"
    },
    points: "140.4,187.6 137.2,191.6  140.4,195.6 143.5,191.6  "
  }), _ref22, _ref23), _ref24), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145030318013469476360000003390691497264423567_",
    gradientUnits: "userSpaceOnUse",
    x1: -1797.3383,
    y1: -3388.1108,
    x2: -1803.6182,
    y2: -3403.9207,
    gradientTransform: "matrix(6.123234e-17 -1 -1 -6.123234e-17 -3325.6299 -1677.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000145030318013469476360000003390691497264423567_)"
    },
    points: "68.2,123.4 72.1,126.5  76.1,123.4 72.1,120.2  "
  }), _ref25, _ref26), _ref27), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091728682492822289330000000953233917651799436_",
    gradientUnits: "userSpaceOnUse",
    x1: -1797.3337,
    y1: -3524.5386,
    x2: -1803.6237,
    y2: -3540.3586,
    gradientTransform: "matrix(6.123234e-17 -1 -1 -6.123234e-17 -3325.6299 -1677.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000091728682492822289330000000953233917651799436_)"
    },
    points: "204.6,123.4 208.6,126.5  212.6,123.4 208.6,120.2  "
  }), _ref28, _ref29), _ref30)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052085636612446101400000004358666985274205119_",
    gradientUnits: "userSpaceOnUse",
    x1: -1265.8917,
    y1: 1957.9032,
    x2: -1272.1816,
    y2: 1942.0931,
    gradientTransform: "matrix(0.7071 0.7071 0.7071 -0.7071 -291.1741 2350.5854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000052085636612446101400000004358666985274205119_)"
    },
    points: "191.4,72.3 186.4,72.9  185.8,77.9 190.8,77.3  "
  }), _ref31, _ref32), _ref33), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144320411527210768370000014718051073467442567_",
    gradientUnits: "userSpaceOnUse",
    x1: -1265.8986,
    y1: 1821.4719,
    x2: -1272.1786,
    y2: 1805.662,
    gradientTransform: "matrix(0.7071 0.7071 0.7071 -0.7071 -291.1741 2350.5854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000144320411527210768370000014718051073467442567_)"
    },
    points: "94.9,168.8 89.9,169.4  89.3,174.4 94.3,173.8  "
  }), _ref34, _ref35), _ref36)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003078210783299964840000001241521176564034438_",
    gradientUnits: "userSpaceOnUse",
    x1: -75.789,
    y1: -1977.9877,
    x2: -82.069,
    y2: -1993.7977,
    gradientTransform: "matrix(0.7071 -0.7071 -0.7071 -0.7071 -1257.0447 -1386.636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000003078210783299964840000001241521176564034438_)"
    },
    points: "89.3,72.3 89.9,77.3  94.9,77.9 94.3,72.9  "
  }), _ref37, _ref38), _ref39), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006708924315355913330000010914384210021258160_",
    gradientUnits: "userSpaceOnUse",
    x1: -75.7892,
    y1: -2114.4175,
    x2: -82.0692,
    y2: -2130.2275,
    gradientTransform: "matrix(0.7071 -0.7071 -0.7071 -0.7071 -1257.0447 -1386.636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000006708924315355913330000010914384210021258160_)"
    },
    points: "185.8,168.8 186.4,173.8  191.4,174.4 190.8,169.4  "
  }), _ref40, _ref41), _ref42)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103979505709696487420000010219367314683523728_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.1,
    y1: 220.4,
    x2: 116.03,
    y2: 220.4,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103979505709696487420000010219367314683523728_)"
    },
    d: "M116,61.6c0,1.9-1.6,3.5-3.5,3.5 s-3.5-1.5-3.5-3.5s1.6-3.5,3.5-3.5S116,59.7,116,61.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003103077872515662820000013196602267547724931_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.2099,
    y1: 228.03,
    x2: 110.5099,
    y2: 212.32,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003103077872515662820000013196602267547724931_)"
    },
    d: "M115.5,61.4c0,1.7-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S115.5,59.7,115.5,61.4z"
  }), _ref43, _ref44), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082337972832084389450000017040890771841425546_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.13,
    y1: 221.66,
    x2: 170.06,
    y2: 221.66,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082337972832084389450000017040890771841425546_)"
    },
    d: "M170.1,60.3c0,1.9-1.6,3.5-3.5,3.5 s-3.5-1.5-3.5-3.5s1.6-3.5,3.5-3.5S170.1,58.4,170.1,60.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074414194940140425770000007615049932598233508_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.2462,
    y1: 229.2809,
    x2: 164.5462,
    y2: 213.5809,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074414194940140425770000007615049932598233508_)"
    },
    d: "M169.6,60.2c0,1.7-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S169.6,58.5,169.6,60.2z"
  }), _ref45, _ref46), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017483039341972493340000012581768980746526628_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.41,
    y1: 186.65,
    x2: 206.35,
    y2: 186.65,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017483039341972493340000012581768980746526628_)"
    },
    d: "M206.4,95.3c0,1.9-1.6,3.5-3.5,3.5 s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5S206.4,93.4,206.4,95.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097488672732227049410000010039377852497926811_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.531,
    y1: 194.2698,
    x2: 200.831,
    y2: 178.5698,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000097488672732227049410000010039377852497926811_)"
    },
    cx: 202.8,
    cy: 95.2,
    r: 3.1
  }), _ref47, _ref48), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100371916694631224820000002685871007288169905_",
    gradientUnits: "userSpaceOnUse",
    x1: 201,
    y1: 134.295,
    x2: 207.93,
    y2: 134.295,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100371916694631224820000002685871007288169905_)"
    },
    d: "M207.9,147.7c0,1.9-1.6,3.5-3.5,3.5 s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5S207.9,145.8,207.9,147.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106138860113890263050000002591117109356147892_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.126,
    y1: 141.9186,
    x2: 202.426,
    y2: 126.2186,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106138860113890263050000002591117109356147892_)"
    },
    d: "M207.4,147.5c0,1.7-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S207.4,145.8,207.4,147.5z"
  }), _ref49, _ref50), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047769196137073798200000000130856240452143235_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.62,
    y1: 133.235,
    x2: 81.55,
    y2: 133.235,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047769196137073798200000000130856240452143235_)"
    },
    d: "M81.6,148.8c0,1.9-1.6,3.5-3.5,3.5 s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5S81.6,146.8,81.6,148.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129909022095867781790000001614607758530963891_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.7288,
    y1: 140.8603,
    x2: 76.0288,
    y2: 125.1603,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129909022095867781790000001614607758530963891_)"
    },
    d: "M81,148.6c0,1.7-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S81,146.9,81,148.6z"
  }), _ref51, _ref52), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098902356242784484730000005660222409566942367_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.37,
    y1: 95.96,
    x2: 118.3,
    y2: 95.96,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098902356242784484730000005660222409566942367_)"
    },
    d: "M118.3,186c0,1.9-1.6,3.5-3.5,3.5 s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5S118.3,184.1,118.3,186z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068646182124168318980000012442677983698868642_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.483,
    y1: 103.5917,
    x2: 112.783,
    y2: 87.8817,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068646182124168318980000012442677983698868642_)"
    },
    d: "M117.8,185.9c0,1.7-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S117.8,184.2,117.8,185.9z"
  }), _ref53, _ref54), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000927730502465723160000018134876677453769883_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.78,
    y1: 97.015,
    x2: 171.71,
    y2: 97.015,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000927730502465723160000018134876677453769883_)"
    },
    d: "M171.7,185c0,1.9-1.6,3.5-3.5,3.5 s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5S171.7,183.1,171.7,185z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031922232722588000100000017233263475375826317_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.895,
    y1: 104.6412,
    x2: 166.185,
    y2: 88.9312,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031922232722588000100000017233263475375826317_)"
    },
    d: "M171.2,184.8c0,1.7-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S171.2,183.1,171.2,184.8z"
  }), _ref55, _ref56), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075155104641379855720000011262459605366053248_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.09,
    y1: 183.21,
    x2: 81.02,
    y2: 183.21,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075155104641379855720000011262459605366053248_)"
    },
    d: "M81,98.8c0,1.9-1.6,3.5-3.5,3.5 s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5S81,96.9,81,98.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178187082003801941710000007204803384510020231_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.2004,
    y1: 190.8423,
    x2: 75.5004,
    y2: 175.1322,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178187082003801941710000007204803384510020231_)"
    },
    d: "M80.5,98.6c0,1.7-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S80.5,96.9,80.5,98.6z"
  }), _ref57, _ref58), _ref59, _ref60, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053531085026709303880000005417470639871955373_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.3218,
    y1: 226.1602,
    x2: 187.7018,
    y2: 202.9602,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000053531085026709303880000005417470639871955373_)",
      enableBackground: "new"
    },
    d: " M188.6,57.5c0,0-1.8-1.3-4.6-0.2s-4.4,0.7-1.9,2.1c2.5,1.4,3.5,0.6,5.2,0.5s2.7,1.2,3.1,0.9S190.4,58.7,188.6,57.5L188.6,57.5 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022526341887854038330000016457802324130289305_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.9403,
    y1: 225.3211,
    x2: 186.7303,
    y2: 217.6511,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022526341887854038330000016457802324130289305_)"
    },
    d: "M187.1,57.2 c-0.4-0.2-3.1-0.2-2.9,0.8C184.5,59,189.9,58.4,187.1,57.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168115579153564747930000009442442930654516143_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.2414,
    y1: 676.5771,
    x2: 19.6214,
    y2: 653.3771,
    gradientTransform: "matrix(0.9849 0.1731 0.1731 -0.9849 69.0713 735.7958)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000168115579153564747930000009442442930654516143_)",
      enableBackground: "new"
    },
    d: " M206.2,74.7c0,0-1.6-1.6-4.5-1s-4.4-0.1-2.2,1.8c2.2,1.8,3.3,1.2,5,1.4c1.7,0.2,2.5,1.7,2.9,1.4 C207.7,78,207.7,76.2,206.2,74.7L206.2,74.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127759831216474332290000008388246669934710462_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.8499,
    y1: 675.7369,
    x2: 18.6299,
    y2: 668.067,
    gradientTransform: "matrix(0.9849 0.1731 0.1731 -0.9849 69.0713 735.7958)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127759831216474332290000008388246669934710462_)"
    },
    d: "M204.7,74c-0.4-0.2-3-0.8-3,0.3 C201.8,75.4,207.2,75.7,204.7,74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004506607508088850030000009080809302420861611_",
    gradientUnits: "userSpaceOnUse",
    x1: -508.9781,
    y1: 1403.043,
    x2: -506.5981,
    y2: 1379.843,
    gradientTransform: "matrix(0.8802 0.4745 0.4745 -0.8802 -1.9766 1570.5912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000004506607508088850030000009080809302420861611_)",
      enableBackground: "new"
    },
    d: " M217.9,97.1c0,0-1-2-4-2.4s-4.2-1.5-2.7,1s2.8,2.2,4.3,2.9c1.5,0.7,1.8,2.4,2.3,2.3C218.4,100.8,218.9,99,217.9,97.1 L217.9,97.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031924961495121967990000003367736747193965214_",
    gradientUnits: "userSpaceOnUse",
    x1: -508.3571,
    y1: 1402.1941,
    x2: -507.5671,
    y2: 1394.5341,
    gradientTransform: "matrix(0.8802 0.4745 0.4745 -0.8802 -1.9766 1570.5912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031924961495121967990000003367736747193965214_)"
    },
    d: "M216.8,96.1 c-0.3-0.3-2.6-1.7-2.9-0.6C213.6,96.5,218.6,98.5,216.8,96.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127010953062902098460000007438935615646276242_",
    gradientUnits: "userSpaceOnUse",
    x1: -1274.2415,
    y1: 1935.5116,
    x2: -1271.8615,
    y2: 1912.3116,
    gradientTransform: "matrix(0.677 0.736 0.736 -0.677 -340.2069 2367.1555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000127010953062902098460000007438935615646276242_)",
      enableBackground: "new"
    },
    d: " M222.6,122.6c0,0-0.3-2.2-3-3.6c-2.7-1.3-3.5-2.8-2.9,0c0.6,2.8,1.9,3,3.1,4.2c1.2,1.2,1,2.8,1.4,2.9 C221.8,126.2,222.9,124.7,222.6,122.6L222.6,122.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077311656593945024000000002898207807208856205_",
    gradientUnits: "userSpaceOnUse",
    x1: -1273.6182,
    y1: 1934.6631,
    x2: -1272.8281,
    y2: 1926.993,
    gradientTransform: "matrix(0.677 0.736 0.736 -0.677 -340.2069 2367.1555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077311656593945024000000002898207807208856205_)"
    },
    d: "M221.9,121.2 c-0.1-0.4-1.9-2.5-2.5-1.6C218.7,120.5,222.9,124.1,221.9,121.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029724675025290590390000002779100272122654644_",
    gradientUnits: "userSpaceOnUse",
    x1: -2147.7766,
    y1: 2177.3042,
    x2: -2145.4268,
    y2: 2154.4141,
    gradientTransform: "matrix(0.4094 0.9123 0.9123 -0.4094 -888.4012 2995.0938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000029724675025290590390000002779100272122654644_)",
      enableBackground: "new"
    },
    d: " M218.6,147.7c0,0,0.4-2.2-1.7-4.3c-2.1-2.1-2.4-3.7-2.7-0.9s0.9,3.4,1.6,4.9c0.7,1.5,0,2.9,0.4,3.2 C216.7,150.8,218.2,149.8,218.6,147.7L218.6,147.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096029149122120785570000002422602426079058088_",
    gradientUnits: "userSpaceOnUse",
    x1: -2147.1787,
    y1: 2176.4739,
    x2: -2146.3987,
    y2: 2168.9041,
    gradientTransform: "matrix(0.4094 0.9123 0.9123 -0.4094 -888.4012 2995.0938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096029149122120785570000002422602426079058088_)"
    },
    d: "M218.3,146.1c0-0.4-1-2.9-1.9-2.2 S218.4,149.1,218.3,146.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044176941031945471590000009233907414444846249_",
    gradientUnits: "userSpaceOnUse",
    x1: -2785.6987,
    y1: 2160.5203,
    x2: -2783.9587,
    y2: 2143.5103,
    gradientTransform: "matrix(0.2058 1.1009 0.983 -0.1838 -1342.8533 3631.4727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000044176941031945471590000009233907414444846249_)",
      enableBackground: "new"
    },
    d: " M207.6,170.2c0,0,0.6-1.6-0.5-3.8c-1.2-2.1-1.2-3.5-1.8-1.2s0.1,2.9,0.4,4.2s-0.5,2.4-0.2,2.6 C205.8,172.3,207,171.8,207.6,170.2L207.6,170.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108296131004398614530000004505664506612801668_",
    gradientUnits: "userSpaceOnUse",
    x1: -2785.2483,
    y1: 2159.9075,
    x2: -2784.6785,
    y2: 2154.2876,
    gradientTransform: "matrix(0.2058 1.1009 0.983 -0.1838 -1342.8533 3631.4727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108296131004398614530000004505664506612801668_)"
    },
    d: "M207.7,168.9c0.1-0.3-0.3-2.6-1-2.2 C205.9,167,207.2,171.3,207.7,168.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076587920953442973680000012585140261109878147_",
    gradientUnits: "userSpaceOnUse",
    x1: -5227.3193,
    y1: 226.32,
    x2: -5224.9395,
    y2: 203.12,
    gradientTransform: "matrix(-1 0 0 -1 -5130.5801 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000076587920953442973680000012585140261109878147_)",
      enableBackground: "new"
    },
    d: " M93.4,57.4c0,0,1.8-1.3,4.6-0.2s4.4,0.7,1.9,2.1s-3.5,0.6-5.2,0.5c-1.7-0.1-2.7,1.2-3.1,0.9S91.7,58.6,93.4,57.4L93.4,57.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042700881272176455460000013356237280327719354_",
    gradientUnits: "userSpaceOnUse",
    x1: -5226.7085,
    y1: 225.4702,
    x2: -5225.9287,
    y2: 217.8102,
    gradientTransform: "matrix(-1 0 0 -1 -5130.5801 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042700881272176455460000013356237280327719354_)"
    },
    d: "M95,57c0.4-0.2,3.1-0.2,2.9,0.8 C97.6,58.9,92.2,58.2,95,57z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043417159869516651110000007467315297325613464_",
    gradientUnits: "userSpaceOnUse",
    x1: -5313.6582,
    y1: -260.6709,
    x2: -5311.2778,
    y2: -283.8709,
    gradientTransform: "matrix(-0.9849 0.1731 -0.1731 -0.9849 -5199.6514 735.7958)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000043417159869516651110000007467315297325613464_)",
      enableBackground: "new"
    },
    d: " M75.9,74.5c0,0,1.6-1.6,4.5-1s4.4-0.1,2.2,1.8c-2.2,1.8-3.3,1.2-5,1.4c-1.7,0.2-2.5,1.7-2.9,1.4C74.3,77.9,74.4,76,75.9,74.5 L75.9,74.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007386881262530766560000014048503641535977912_",
    gradientUnits: "userSpaceOnUse",
    x1: -5313.0566,
    y1: -261.5218,
    x2: -5312.2769,
    y2: -269.1818,
    gradientTransform: "matrix(-0.9849 0.1731 -0.1731 -0.9849 -5199.6514 735.7958)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007386881262530766560000014048503641535977912_)"
    },
    d: "M77.4,73.9c0.3-0.2,3-0.8,3,0.3 C80.3,75.3,74.8,75.6,77.4,73.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067930729812380502570000018078977804162065044_",
    gradientUnits: "userSpaceOnUse",
    x1: -5273.46,
    y1: -1164.9902,
    x2: -5271.0801,
    y2: -1188.1902,
    gradientTransform: "matrix(-0.8802 0.4745 -0.4745 -0.8802 -5128.6133 1570.5912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000067930729812380502570000018078977804162065044_)",
      enableBackground: "new"
    },
    d: " M64.1,97c0,0,1-2,4-2.4s4.2-1.5,2.7,1s-2.8,2.2-4.3,2.9c-1.5,0.7-1.8,2.4-2.3,2.3C63.7,100.7,63.2,98.9,64.1,97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165947350297236427310000013912624366700458149_",
    gradientUnits: "userSpaceOnUse",
    x1: -5272.8413,
    y1: -1165.8394,
    x2: -5272.0513,
    y2: -1173.4994,
    gradientTransform: "matrix(-0.8802 0.4745 -0.4745 -0.8802 -5128.6133 1570.5912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165947350297236427310000013912624366700458149_)"
    },
    d: "M65.3,95.9c0.3-0.3,2.6-1.7,2.9-0.6 S63.4,98.3,65.3,95.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161622191575378772600000008881108858844321447_",
    gradientUnits: "userSpaceOnUse",
    x1: -4938.7363,
    y1: -2047.9993,
    x2: -4936.356,
    y2: -2071.1992,
    gradientTransform: "matrix(-0.677 0.736 -0.736 -0.677 -4790.3833 2367.1555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000161622191575378772600000008881108858844321447_)",
      enableBackground: "new"
    },
    d: " M59.4,122.4c0,0,0.3-2.2,3-3.6c2.7-1.3,3.5-2.8,2.8,0c-0.6,2.8-1.9,3-3.1,4.2c-1.2,1.2-1,2.8-1.4,2.9 C60.2,126,59.2,124.5,59.4,122.4L59.4,122.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029020022790004242720000008483987109355409587_",
    gradientUnits: "userSpaceOnUse",
    x1: -4938.1289,
    y1: -2048.8496,
    x2: -4937.3389,
    y2: -2056.5095,
    gradientTransform: "matrix(-0.677 0.736 -0.736 -0.677 -4790.3833 2367.1555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029020022790004242720000008483987109355409587_)"
    },
    d: "M60.2,121c0.1-0.4,1.9-2.4,2.5-1.6 C63.3,120.4,59.2,123.9,60.2,121z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103239151666951378890000015157733959082244524_",
    gradientUnits: "userSpaceOnUse",
    x1: -4281.564,
    y1: -2822.1907,
    x2: -4279.5239,
    y2: -2842.0105,
    gradientTransform: "matrix(-0.3927 0.9197 -0.9197 -0.3927 -4213.6958 2973.7144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000103239151666951378890000015157733959082244524_)",
      enableBackground: "new"
    },
    d: " M63.5,147.5c0,0-0.4-1.9,1.4-3.7c1.8-1.9,2-3.2,2.3-0.8c0.3,2.4-0.7,2.9-1.3,4.2c-0.6,1.3,0,2.6-0.3,2.8 S63.8,149.2,63.5,147.5L63.5,147.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070107261757591149970000001869014597904838333_",
    gradientUnits: "userSpaceOnUse",
    x1: -4281.0337,
    y1: -2822.9207,
    x2: -4280.3638,
    y2: -2829.4707,
    gradientTransform: "matrix(-0.3927 0.9197 -0.9197 -0.3927 -4213.6958 2973.7144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070107261757591149970000001869014597904838333_)"
    },
    d: "M63.7,146.1c0-0.4,0.9-2.5,1.6-2 C66,144.7,63.7,148.7,63.7,146.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175319987445638395940000014607451031603015822_",
    gradientUnits: "userSpaceOnUse",
    x1: -3147.551,
    y1: -3425.7654,
    x2: -3145.521,
    y2: -3445.5852,
    gradientTransform: "matrix(3.036402e-02 0.9995 -0.9995 3.036402e-02 -3255.0688 3418.8081)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000175319987445638395940000014607451031603015822_)",
      enableBackground: "new"
    },
    d: " M75.2,171.5c0,0-1.2-1.5-0.3-3.9c0.8-2.4,0.5-3.8,1.8-1.7c1.3,2.1,0.6,3,0.6,4.4c0,1.4,1.1,2.3,0.9,2.6 C77.8,173.2,76.3,172.9,75.2,171.5L75.2,171.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008130456004011861140000016964899550903614896_",
    gradientUnits: "userSpaceOnUse",
    x1: -3147.0244,
    y1: -3426.4846,
    x2: -3146.3542,
    y2: -3433.0347,
    gradientTransform: "matrix(3.036402e-02 0.9995 -0.9995 3.036402e-02 -3255.0688 3418.8081)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008130456004011861140000016964899550903614896_)"
    },
    d: "M74.8,170.2 c-0.2-0.3-0.3-2.6,0.6-2.5S75.9,172.5,74.8,170.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144326503581159089220000015526893674140973748_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.817,
    y1: 238.4407,
    x2: 169.057,
    y2: 197.1407,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000144326503581159089220000015526893674140973748_)",
      enableBackground: "new"
    },
    d: " M167,46.1c0,0-2.4-1.4-5,0.3c-2.9,2,1,0.7,3,2.8s3.4,4,4.4,3.8C170.4,52.8,169.7,47.9,167,46.1L167,46.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131368927125179631780000007170046643722538916_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.7032,
    y1: 237.0003,
    x2: 167.4332,
    y2: 220.0803,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131368927125179631780000007170046643722538916_)"
    },
    d: "M164.7,45.9c0,0-1.9,0.3-0.4,1.5 c1.6,1.2,3.4,2,3.7,1.1S167.2,46,164.7,45.9L164.7,45.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049915847565513276780000014906872123573316263_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.535,
    y1: -684.3069,
    x2: 261.775,
    y2: -725.6169,
    gradientTransform: "matrix(0.9482 -0.3176 -0.3176 -0.9482 -322.4132 -526.9537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000049915847565513276780000014906872123573316263_)",
      enableBackground: "new"
    },
    d: " M142.1,41.8c0,0-2.8-0.6-4.6,1.9c-2.1,2.8,1.1,0.3,3.7,1.7c2.6,1.4,4.5,2.7,5.4,2.2C147.4,47.1,145.2,42.7,142.1,41.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026151421381316869700000002782601330991895432_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.4183,
    y1: -685.7576,
    x2: 260.1483,
    y2: -702.6676,
    gradientTransform: "matrix(0.9482 -0.3176 -0.3176 -0.9482 -322.4132 -526.9537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026151421381316869700000002782601330991895432_)"
    },
    d: "M139.8,42.4c0,0-1.7,0.9,0.1,1.5 c1.9,0.6,3.9,0.8,3.9-0.1S142.2,41.7,139.8,42.4L139.8,42.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018237191548017771600000002464268176044553624_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.911,
    y1: 237.9759,
    x2: 129.961,
    y2: 206.9659,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000018237191548017771600000002464268176044553624_)",
      enableBackground: "new"
    },
    d: " M117.4,45.8c0,0-2.3-0.3-3.7,1.6c-1.4,1.9,0.6,1.6,3,1.3c2.4-0.3,3.9,1.2,5.9,1.1C124.7,49.8,120,45.6,117.4,45.8L117.4,45.8z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159457844279382057790000011692535601066732174_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.8026,
    y1: 236.9512,
    x2: 122.7926,
    y2: 223.7212,
    gradientTransform: "matrix(1 0 0 -1 0 282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDE33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79228"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159457844279382057790000011692535601066732174_)"
    },
    d: "M118.3,46.2c0,0-3.3-0.4-3.1,0.7 c0.2,1,3.5,1,4.6,0.6C120.9,47.1,119.1,46.3,118.3,46.2L118.3,46.2z"
  }), _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68)))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ8);
export default __webpack_public_path__ + "static/media/q8.7cb90f3fe030e7d7c453f58f609deba3.svg";
export { ForwardRef as ReactComponent };